import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { itemsPerPageValue } from "../../../utils/ItemsPerPageValue";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import axios from "axios";
import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import ItemsPerPageSelect from "../../elements/filter/ItemsPerPageSelect";
import Notification from "../../elements/notification/Notification";
import FeeList from "./FeeList";
import FeeFilter from "./FeeFilter";
import FilterAppliedList from "../../elements/filter/FilterAppliedList";
import { AppContext } from "../../../App";
import { useTranslation } from "react-i18next";

import MaterialPagination from "../../styles/materialPagination";
import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledFeeWrapper } from "../styledFee";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";

const FeeContainer = () => {
  const { t } = useTranslation("feePage");

  const [fees, setFees] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const { user } = useContext(AppContext);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "service.name": checkFilterItem(history, "service.name", null),
    "paymentSystem.name": checkFilterItem(history, "paymentSystem.name", null),
    "currency.asset": checkFilterItem(history, "currency.asset", null),
    "type": checkFilterItem(history, "type", null),
    "percent[gte]": checkFilterItem(history, "percent[gte]", null, true),
    "percent[lte]": checkFilterItem(history, "percent[lte]", null, true),
    "constant[gte]": checkFilterItem(history, "constant[gte]", null, true),
    "constant[lte]": checkFilterItem(history, "constant[lte]", null, true),
    "min[gte]": checkFilterItem(history, "min[gte]", null, true),
    "min[lte]": checkFilterItem(history, "min[lte]", null, true),
    "max[gte]": checkFilterItem(history, "max[gte]", null, true),
    "max[lte]": checkFilterItem(history, "max[lte]", null, true)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchBaseFee = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/base-fees" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setFees(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  //TODO add pusher
  useEffect(() => {
    fetchBaseFee();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.title")}</title>
        </Helmet>
        <StyledFeeWrapper>
          <div className="admin-filter">
            <FeeFilter
              filterData={filterData}
              setFilterData={setFilterData}
            />
            <ItemsPerPageSelect
              itemsPerPage={filterData.itemsPerPage}
              setItemsPerPage={(data) => setFilterData({
                ...filterData,
                "itemsPerPage": data,
                page: 1
              })}
            />
          </div>
          <FilterAppliedList
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <FeeList
            fees={fees}
            notification={notification}
            setNotification={setNotification}
            fetchBaseFee={fetchBaseFee}
          />
          {totalPageCount > 1  &&
            <MaterialPagination
              count={totalPageCount}
              shape="rounded"
              page={filterData.page}
              onChange={(event, page) => onChangePage(event, page)}
            />}
        </StyledFeeWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default FeeContainer;